module.exports = __webpack_public_path__ + "images/6-i-oldcbbefd133f7c280c0f248cf3a9c972f8.svg";